import { LayerManager } from 'models';

// This is expected to change shortly.
const stages = {
    bf_1a: 'bf_not_started',
    bf_1b: 'bf_workshop_1_commenced',
    bf_1c: 'bf_workshop_1_processing',
    bf_1d: 'bf_workshop_1_completed',
    bf_2a: 'bf_workshop_2_commenced',
    bf_2b: 'bf_workshop_2_processing',
    bf_2c: 'bf_workshop_2_completed',
    bf_3a: 'bf_workshop_3_commenced',
    bf_3b: 'bf_workshop_3_processing',
    bf_3c: 'bf_workshop_3_completed',
    bf_4a: 'bf_workshop_4_commenced',
    bf_4b: 'bf_workshop_4_processing',
    bf_4c: 'bf_workshop_4_completed',
    bf_4d: 'bf_workshop_4_approved',
    faft_1a: 'faft_not_started',
    faft_1b: 'faft_pre_workshop_commenced',
    faft_1c: 'faft_pre_workshop_completed',
    faft_2a: 'faft_workshop_1_commenced',
    faft_2b: 'faft_workshop_1_completed',
    faft_3a: 'faft_workshop_2_3_commenced',
    faft_3b: 'faft_workshop_2_3_completed',
    faft_4a: 'faft_workshop_4_commenced',
    faft_4b: 'faft_workshop_4_completed',
    faft_4c: 'faft_workshop_4_approved',
};

export const checkToolPermissions = (
    workshopState: string | null,
    userRoles: string[],
    tool: string,
) => {
    let allowedRoles = [''];
    switch (workshopState) {
        case null:
        case '':
        case stages.bf_1a:
        case stages.bf_2c:
        case stages.bf_3c:
            switch (tool) {
                case 'view_layers':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_fmr_download':
                case 'focus_area_upload':
                case 'focus_fmr_upload':
                default:
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
            }

        case stages.bf_1b:
        case stages.bf_2a:
        case stages.bf_3a:
            switch (tool) {
                case 'comments_and_drawing_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_area_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'fmr_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_fmr_download':
                case 'focus_area_upload':
                case 'focus_fmr_upload':
                default:
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
            }
        case stages.bf_1c:
            switch (tool) {
                case 'comments_and_drawing_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_area_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'fmr_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_fmr_download':
                case 'focus_area_upload':
                case 'focus_fmr_upload':
                default:
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
            }
        case stages.bf_1d:
            switch (tool) {
                case 'comments_and_drawing_tool':
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_area_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'fmr_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_fmr_download':
                case 'focus_area_upload':
                case 'focus_fmr_upload':
                default:
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
            }
        case stages.bf_2b:
        case stages.bf_3b:
            switch (tool) {
                case 'comments_and_drawing_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_area_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'fmr_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_fmr_download':
                case 'focus_area_upload':
                case 'focus_fmr_upload':
                default:
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
            }
        case stages.bf_4a:
            switch (tool) {
                case 'comments_and_drawing_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_area_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'fmr_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_fmr_download':
                case 'focus_area_upload':
                case 'focus_fmr_upload':
                default:
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
            }
        case stages.bf_4b:
            switch (tool) {
                case 'comments_and_drawing_tool':
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_area_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'fmr_tool':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                    ];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
                case 'focus_fmr_download':
                case 'focus_area_upload':
                case 'focus_fmr_upload':
                default:
                    allowedRoles = ['Project Manager', 'Project Admin'];
                    return userRoles.some((item) =>
                        allowedRoles.includes(item),
                    );
            }
        case stages.bf_4c:
        case stages.bf_4d:
            switch (tool) {
                case 'comments_and_drawing_tool':
                    allowedRoles = ['Project Manager'];
                    break;
                case 'focus_area_tool':
                    allowedRoles = ['Project Manager'];
                    break;
                case 'fmr_tool':
                    allowedRoles = ['Project Manager'];
                    break;
                case 'focus_fmr_download':
                    allowedRoles = [
                        'Project Manager',
                        'Project Admin',
                        'BMC Support',
                        'BMC Executive Officer',
                        'BMC Member',
                    ];
                    break;
                default:
                    allowedRoles = ['Project Manager'];
                    break;
            }
            return userRoles.some((item) => allowedRoles.includes(item));
        case stages.faft_2b:
            switch (tool) {
                case 'edit-geometry':
                    return false;
                case 'firetrail-upload-data':
                    return false;
                case 'firetrail-copy-from':
                    return false;
                case 'firetrail-add-new':
                    return false;
                case 'firetrail-delete':
                    return false;
                default:
                    return true;
            }
        case stages.faft_3a:
            switch (tool) {
                case 'edit-geometry':
                    return false;
                case 'firetrail-upload-data':
                    return false;
                case 'firetrail-copy-from':
                    return false;
                case 'firetrail-add-new':
                    return false;
                case 'firetrail-delete':
                    return false;
                default:
                    return true;
            }
        case stages.faft_3b:
            switch (tool) {
                case 'edit-geometry':
                    return false;
                case 'firetrail-upload-data':
                    return false;
                case 'firetrail-copy-from':
                    return false;
                case 'firetrail-add-new':
                    return false;
                case 'firetrail-delete':
                    return false;
                default:
                    return true;
            }
        case stages.faft_4a:
            switch (tool) {
                case 'edit-geometry':
                    return false;
                case 'firetrail-upload-data':
                    return false;
                case 'firetrail-copy-from':
                    return false;
                case 'firetrail-add-new':
                    return false;
                case 'firetrail-delete':
                    return false;
                default:
                    return true;
            }
        case stages.faft_4b:
            switch (tool) {
                case 'edit-geometry':
                    return false;
                case 'firetrail-upload-data':
                    return false;
                case 'firetrail-copy-from':
                    return false;
                case 'firetrail-add-new':
                    return false;
                case 'firetrail-delete':
                    return false;
                default:
                    return true;
            }
        case stages.faft_4c:
            switch (tool) {
                case 'edit-faft-register':
                    return false;
                case 'edit-faft':
                    return false;
                case 'delete-faft-register':
                    return false;
                case 'edit-geometry':
                    return false;
                case 'firetrail-upload-data':
                    return false;
                case 'firetrail-copy-from':
                    return false;
                case 'firetrail-add-new':
                    return false;
                case 'firetrail-delete':
                    return false;
                default:
                    return true;
            }

        default:
            return true;
    }
};

export const nextStageAllowed = (
    workshopState: string | null,
    userRoles: string[],
) => {
    let allowedRoles = [''];
    switch (workshopState) {
        case null:
        case stages.bf_1a:
        case stages.bf_1d:
        case stages.bf_2c:
            allowedRoles = ['Project Manager', 'Project Admin'];
            return userRoles.some((item) => allowedRoles.includes(item));
        case stages.bf_1b:
        case stages.bf_1c:
        case stages.bf_2a:
        case stages.bf_2b:
        case stages.bf_3a:
        case stages.bf_3b:
        case stages.bf_3c:
        case stages.bf_4a:
            allowedRoles = ['Project Manager', 'Project Admin', 'BMC Support'];
            return userRoles.some((item) => allowedRoles.includes(item));
        case stages.bf_4b:
            allowedRoles = ['Project Manager', 'Project Admin'];
            return userRoles.some((item) => allowedRoles.includes(item));
        case stages.bf_4c:
        case stages.bf_4d:
            allowedRoles = ['Project Manager'];
            return userRoles.some((item) => allowedRoles.includes(item));
        default:
            allowedRoles = ['Project Manager', 'Project Admin'];
            return userRoles.some((item) => allowedRoles.includes(item));
    }
};

/**
 * Asset-class groups under the Risk Results section. Hidden wholesale at
 * bf_not_started and Workshop 1; visible at Workshop 2+ (with a per-layer
 * carve-out for _FuturePostTreatment/_Reduction at W2).
 */
const RISK_ASSET_GROUPS: LayerManager.Layer.Group[] = [
    'Economic',
    'Environmental',
    'Residential',
    'Times Burnt',
];

const ALWAYS_HIDDEN_RISK_GROUPS: LayerManager.Layer.Group[] = [
    'Aboriginal Known',
    'Aboriginal Predicted',
    'Historic Heritage',
    'Residential Embers',
    'Residential By Grid',
    'Special Fire Protection Purpose (SFPP)',
];

/**
 * Layer IDs ending in these suffixes describe treatment-dependent outputs:
 * _FuturePostTreatment is the post-treatment future raster; _Reduction is the
 * reduction in risk attributable to treatments. Neither is meaningful at
 * Workshop 2 because treatments haven't been proposed yet — they only exist
 * from Workshop 3 onwards.
 */
const isPostTreatmentRiskLayer = (id: string) =>
    id.startsWith('Risk_') &&
    (id.endsWith('_FuturePostTreatment') || id.endsWith('_Reduction'));

export const checkLayerDisabled = (
    workshopState: string | undefined,
    layerConfig: LayerManager.LayerConfig,
) => {
    const layerGroup = layerConfig.group;
    const layerSection = layerConfig.section;
    const layerID = layerConfig.id;

    if (layerSection !== 'Risk Results') return false;

    switch (workshopState) {
        case null:
        case undefined:
        case stages.bf_1a:
            // Plan hasn't started — entire Risk Results section locked.
            return true;
        case stages.bf_1b:
        case stages.bf_1c:
        case stages.bf_1d:
            // Workshop 1 (Data Validation): only the Preliminary group is
            // surfaced; all asset-class results are hidden until W2.
            return layerGroup !== 'Preliminary Risk Layers';
        case stages.bf_2a:
        case stages.bf_2b:
        case stages.bf_2c:
            // Workshop 2 (Risk Assessment): hide Preliminary (its purpose
            // ended at W1) AND treatment-dependent variants (no treatments
            // proposed yet, so post-treatment future + treatment-reduction
            // would be meaningless).
            if (layerGroup === 'Preliminary Risk Layers') return true;
            return isPostTreatmentRiskLayer(layerID);
        case stages.bf_3a:
        case stages.bf_3b:
        case stages.bf_3c:
        case stages.bf_4a:
        case stages.bf_4b:
        case stages.bf_4c:
        case stages.bf_4d:
        case stages.faft_1a:
        case stages.faft_1b:
        case stages.faft_1c:
        case stages.faft_2a:
        case stages.faft_2b:
        case stages.faft_3a:
        case stages.faft_3b:
        case stages.faft_4a:
        case stages.faft_4b:
        case stages.faft_4c:
            // Workshop 3 onwards (BMAP + all FAFT): full risk picture is
            // available; only the Preliminary group is hidden (stale).
            return layerGroup === 'Preliminary Risk Layers';
        default:
            return false;
    }
};

export const getHiddenGroups = (
    workshopState: string | undefined,
): string[] => {
    switch (workshopState) {
        case null:
        case undefined:
        case stages.bf_1a:
            // Plan not started — every Risk Results group hidden.
            return [
                ...RISK_ASSET_GROUPS,
                ...ALWAYS_HIDDEN_RISK_GROUPS,
                'Preliminary Risk Layers',
            ];
        case stages.bf_1b:
        case stages.bf_1c:
        case stages.bf_1d:
            // Workshop 1 — only Preliminary is visible.
            return [...RISK_ASSET_GROUPS, ...ALWAYS_HIDDEN_RISK_GROUPS];
        case stages.bf_2a:
        case stages.bf_2b:
        case stages.bf_2c:
        case stages.bf_3a:
        case stages.bf_3b:
        case stages.bf_3c:
        case stages.bf_4a:
        case stages.bf_4b:
        case stages.bf_4c:
        case stages.bf_4d:
        case stages.faft_1a:
        case stages.faft_1b:
        case stages.faft_1c:
        case stages.faft_2a:
        case stages.faft_2b:
        case stages.faft_3a:
        case stages.faft_3b:
        case stages.faft_4a:
        case stages.faft_4b:
        case stages.faft_4c:
            // Workshop 2+ (and all FAFT) — asset-class groups visible,
            // Preliminary hidden. checkLayerDisabled handles the W2
            // _FuturePostTreatment/_Reduction carve-out at layer granularity.
            return [...ALWAYS_HIDDEN_RISK_GROUPS, 'Preliminary Risk Layers'];
        default:
            // Unknown stage — lock everything as a safe default.
            return [
                ...RISK_ASSET_GROUPS,
                ...ALWAYS_HIDDEN_RISK_GROUPS,
                'Preliminary Risk Layers',
            ];
    }
};

// User priviledges are not exclusive, but often the highest is what matters...
export const highestUserPriviledge = (myRoles: string[] | undefined) => {
    if (myRoles?.includes('Project Manager')) return 'Project Manager';
    else if (myRoles?.includes('Project Admin')) return 'Project Admin';
    else if (myRoles?.includes('BMC Support')) return 'BMC Support';
    else if (myRoles?.includes('BMC Executive Officer'))
        return 'BMC Executive Officer';
    else return 'BMC Member';
};

export const checkUserEditPrivileges = (
    myRole: string | undefined,
    theirRole: string | undefined,
) => {
    switch (myRole) {
        case 'Project Manager':
            return false;
        case 'Project Admin':
            return theirRole === 'Project Manager';
        case 'BMC Support':
            return (
                theirRole === 'Project Manager' || theirRole === 'Project Admin'
            );
        case 'BMC Executive Officer':
            return (
                theirRole === 'Project Manager' ||
                theirRole === 'Project Admin' ||
                theirRole === 'BMC Support'
            );
        default:
            return true;
    }
};

export const checkStage1Privileges = (
    userRoles: string[],
    workshopStage: string | undefined,
): boolean => {
    const allowedRoles = [
        'Project Manager',
        'Project Admin',
        'BMC Support',
        'BMC Executive Officer',
    ];
    if (
        (workshopStage == 'bf_not_started' || workshopStage == undefined) &&
        !userRoles.some((item) => allowedRoles.includes(item))
    ) {
        return true;
    } else {
        return false;
    }
};

export const doesResourceBelongToUser =
    (ignoreWithAdminPermissions = true) =>
    (
        isAdmin = false,
        userId?: number | undefined,
        resourceId?: number | undefined,
    ) => {
        if (ignoreWithAdminPermissions && isAdmin) return true;
        if (userId === undefined || resourceId === undefined) return false;
        return userId === resourceId;
    };

export const isToolEnabledForStage =
    (tool: string | null) =>
    (stage: string | null, roles: string[] | undefined) => {
        if (!roles || !tool || !stage) return false;
        return checkToolPermissions(stage, roles, tool);
    };

export const isCommentFunctionalityEnabledForStage = isToolEnabledForStage(
    'comments_and_drawing_tool',
);
export const isFocusAreaToolEnabledForStage =
    isToolEnabledForStage('focus_area_tool');
export const isFmrToolEnabledForStage = isToolEnabledForStage('fmr_tool');
